// Design-services taxonomy for the Custom Project Inquiry (Train 8).
// Grouped for a scannable multi-select experience. No motion / video / animation.

export const CUSTOM_SERVICE_GROUPS = [
    {
        id: "branding",
        title: "Branding",
        subtitle: "Strategy, identity, visual system.",
        services: [
            { id: "brand-strategy", label: "Brand Strategy" },
            { id: "logo-design", label: "Logo Design" },
            { id: "brand-identity", label: "Brand Identity" },
            { id: "brand-guidelines", label: "Brand Guidelines" },
            { id: "creative-direction", label: "Creative Direction" },
        ],
    },
    {
        id: "direction",
        title: "Creative Direction",
        subtitle: "Visual leadership across campaigns and social.",
        services: [
            { id: "visual-direction", label: "Visual Direction" },
            { id: "campaign-visual-direction", label: "Campaign Visual Direction" },
            { id: "social-brand-system", label: "Social Brand System" },
        ],
    },
    {
        id: "digital",
        title: "Digital",
        subtitle: "Interface, experience and web presence.",
        services: [
            { id: "website-ui-ux", label: "Website UI/UX" },
            { id: "landing-page-design", label: "Landing Page Design" },
            { id: "website-visual-direction", label: "Website Visual Direction" },
            { id: "digital-brand-experience", label: "Digital Brand Experience" },
        ],
    },
    {
        id: "applications",
        title: "Brand Applications",
        subtitle: "Where the brand lives in the real world.",
        services: [
            { id: "packaging", label: "Packaging" },
            { id: "presentation-pitch-deck", label: "Presentation / Pitch Deck" },
            { id: "stationery-collateral", label: "Stationery & Collateral" },
            { id: "social-media-design", label: "Social Media Design" },
        ],
    },
    {
        id: "other",
        title: "Other",
        subtitle: "Something we didn’t list — we’ll scope with you.",
        services: [
            { id: "other-scope", label: "Other (describe in Vision)" },
        ],
    },
];

// Flat lookup for label resolution.
export const CUSTOM_SERVICE_LABEL_BY_ID = CUSTOM_SERVICE_GROUPS.reduce((acc, g) => {
    g.services.forEach((s) => { acc[s.id] = s.label; });
    return acc;
}, {});

export const resolveServiceLabel = (id) => CUSTOM_SERVICE_LABEL_BY_ID[id] || id;
